import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../styles/components';

const CTAContainer = styled.section`
  background-color: var(--accent-1);
  padding: var(--spacing-xl) 0;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
`;

const CTAContent = styled.div`
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 var(--spacing-md);
  text-align: center;
  position: relative;
  z-index: 1;
`;

const CTAHeading = styled.h2`
  font-size: 3rem;
  margin-bottom: var(--spacing-lg);
  text-transform: uppercase;
  
  span {
    color: var(--accent-2);
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const CTASubheading = styled.p`
  font-size: 1.25rem;
  max-width: 700px;
  margin: 0 auto var(--spacing-xl);
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--spacing-md);
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-sm);
  }
`;

const PhoneButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--secondary);
  color: var(--primary);
  padding: 12px 24px;
  font-weight: 700;
  text-transform: uppercase;
  transition: all 0.3s ease;
  font-size: 0.875rem;
  letter-spacing: 1px;
  
  &:hover {
    background-color: var(--accent-3);
    transform: translateY(-2px);
  }
  
  &:before {
    content: '📞';
    margin-right: var(--spacing-xs);
  }
`;

const CTA: React.FC = () => {
  return (
    <CTAContainer>
      <CTAContent>
        <CTAHeading>
          Schedule Your <span>Expert Service</span> Today
        </CTAHeading>
        <CTASubheading>
          Our factory-trained technicians are ready to provide your European or Japanese
          vehicle with the precision care it deserves.
        </CTASubheading>
        <ButtonGroup>
          <PrimaryButton as="a" href="#contact">
            Book Appointment
          </PrimaryButton>
          <PhoneButton href="tel:4158826075">
            (415) 882-6075
          </PhoneButton>
        </ButtonGroup>
      </CTAContent>
    </CTAContainer>
  );
};

export default CTA; 